import {qs} from '@shared/helpers/queryString'

/**
 * 전달된 window.location object에서 쿼리 정보 파싱하여 리턴
 * @param target
 */
export const getQuery = <T extends object>(target: Window = window): Partial<T> => {
    const search = target.location.search
    if (search) {
        return qs.parse(search) || {}
    }
    return {}
}

/**
 * 전달된 window.location object에서 url 정보 파싱하여 리턴
 * @param target
 */
export const getUrlInfoByWindow = (target: Window = window) => {
    const {origin, pathname, href} = target.location
    return {
        url: href,
        path: origin + pathname === '/' ? '' : pathname,
        query: getQuery(target),
    }
}
